import { css } from "styled-components";

/** Tipografia Bilíngua — valores em px, alinhados ao app mobile (Manrope). */
export const fontSizes = {
  xs: 11,
  sm: 14,
  md: 14,
  base: 19,
  lg: 19,
  xl: 24,
  "2xl": 24,
  "3xl": 33,
  "4xl": 33,
  "5xl": 44,
  "6xl": 44,
} as const;

export const lineHeights = {
  xs: 19,
  sm: 24,
  md: 24,
  base: 32,
  lg: 32,
  xl: 41,
  "2xl": 41,
  "3xl": 56,
  "4xl": 56,
  "5xl": 75,
  "6xl": 75,
} as const;

export const md3TitleMedium = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: 600;
`;

export const md3TitleLarge = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.xl}px;
  line-height: ${lineHeights.xl}px;
  font-weight: 700;
`;

export const md3BodyMedium = css`
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: 400;
`;

export const md3BodyLarge = css`
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: 400;
`;

export const md3LabelLarge = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: 600;
`;

export const sectionTitle = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.xl}px;
  line-height: ${lineHeights.xl}px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textTitle};
`;

export const countBadgeText = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: 700;
`;

export const actionTileTitle = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: 600;
  text-align: center;
`;

export const actionListTitle = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.base}px;
  line-height: ${lineHeights.base}px;
  font-weight: 600;
`;

export const actionListSubtitle = css`
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

/** Meta / caption (datas, chips auxiliares) */
export const metaCaption = css`
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textTertiary};
`;

/** Empty-state title */
export const emptyStateTitle = css`
  font-family: ${({ theme }) => theme.font.familyHeading};
  font-size: ${fontSizes.xl}px;
  line-height: ${lineHeights.xl}px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textTitle};
`;

export const cardRadiusXl = css`
  border-radius: ${({ theme }) => theme.borderRadius.xl}px;
`;

export const cardRadiusExpressive = css`
  border-radius: ${({ theme }) => theme.md3.shape.extraLarge}px;
`;
